import React from 'react';
import {connect} from 'react-redux';
import AnonymousRequired from 'components/AnonymousRequired';

import Logo from 'components/Logo';
import {ForgotPasswordSetForm} from './components';

import {setForgotPasswordToken} from 'ducks/auth';

import './styles.css';

class ForgotPasswordSet extends React.Component<any> {
  componentDidMount() {
    const {token} = this.props.match.params;
    this.props.setForgotPasswordToken({token});
  }
  render() {
    return (
      <div className="ForgotPasswordSet">
        <div className="content">
          <Logo white={true} />
          <ForgotPasswordSetForm />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  setForgotPasswordToken
};

export default connect(null, mapDispatchToProps)(
  AnonymousRequired(ForgotPasswordSet)
);
